/* Labels produits (appli Labeler) : empile les pictos les uns sous les autres,
   sans superposition et sans trou, quel que soit leur nombre. */
(function () {
  var GAP = 4;    // espace entre deux pictos (px)
  var START = 6;  // marge haut/gauche dans l'image (px)

  function stack(fig) {
    var boxes = Array.prototype.filter.call(fig.children, function (b) {
      return b.classList.contains('aco-box') && b.querySelector('img.aco-image') && b.offsetHeight > 0;
    });
    if (!boxes.length) return;
    boxes.forEach(function (b) {
      if (!b.dataset.acoOrder) b.dataset.acoOrder = parseFloat(b.style.top) || 0;
    });
    boxes.sort(function (a, b) { return a.dataset.acoOrder - b.dataset.acoOrder; });
    var y = START;
    boxes.forEach(function (b) {
      var top = y + 'px';
      if (b.style.top !== top || b.style.getPropertyPriority('top') !== 'important') {
        b.style.setProperty('top', top, 'important');
        b.style.setProperty('left', START + 'px', 'important');
        b.style.setProperty('bottom', 'auto', 'important');
      }
      y += b.offsetHeight + GAP;
    });
  }

  var pending = false;
  function run() {
    pending = false;
    document.querySelectorAll('figure.product-featured-image').forEach(stack);
  }
  function schedule() { if (!pending) { pending = true; requestAnimationFrame(run); } }

  function start() {
    new MutationObserver(function (list) {
      for (var i = 0; i < list.length; i++) {
        var m = list[i];
        if (m.type === 'childList') { schedule(); return; }
        if (m.target.classList && m.target.classList.contains('aco-box')) { schedule(); return; }
      }
    }).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['style'] });
    window.addEventListener('resize', schedule);
    schedule();
  }
  if (document.body) start(); else document.addEventListener('DOMContentLoaded', start);
})();